import { Node, mergeAttributes } from '@tiptap/core';
import { VueNodeViewRenderer } from '@tiptap/vue-2';

import FormulaAdapter from '../FormulaChip/FormulaAdapter.vue';
import { FORMULAS_HTML_TAG } from '../FormulaChip/formulas.const';

export default Node.create({
	name: 'FormulasExtensions',

	group: 'inline',

	// content: 'inline*', // this caused a major bug of 'inlining the component as text' after keystroke

	inline: true,

	selectable: true,

	atom: true,
	defining: true, //If a node should be kept for such replace operations (e.g. copy paste)
	// isolating: true, // fence backspace

	addAttributes() {
		return {
			content: { default: 'no_content_found' },
		};
	},
	parseHTML() {
		return [{ tag: FORMULAS_HTML_TAG }];
	},

	renderHTML({ HTMLAttributes }) {
		return [FORMULAS_HTML_TAG, mergeAttributes(HTMLAttributes)];
	},
	// Used to convert an atom node to plain text
	renderText({ node }) {
		return `@${node.attrs.id}`;
	},

	addNodeView() {
		return VueNodeViewRenderer(FormulaAdapter);
	},
});
